/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_News_Writtenby1Inputs */

const ja_playdata_news_writtenby1 = /** @type {(inputs: Playdata_News_Writtenby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`執筆`)
};

const en_playdata_news_writtenby1 = /** @type {(inputs: Playdata_News_Writtenby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written By`)
};

/**
* | output |
* | --- |
* | "Written By" |
*
* @param {Playdata_News_Writtenby1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_news_writtenby1 = /** @type {((inputs?: Playdata_News_Writtenby1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_News_Writtenby1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_news_writtenby1(inputs)
	return en_playdata_news_writtenby1(inputs)
});
export { playdata_news_writtenby1 as "playdata_news_writtenBy" }